import React from 'react';
import PropTypes from 'prop-types';
import { computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import Grid from '@material-ui/core/Grid';
import Skeleton from '@material-ui/lab/Skeleton';

import VersionChangesInput from './VersionChangesInput';
import { FormStepContext } from './FormStep';
import Scenario from '../../api/Scenario';


@observer
class VersionChangesField extends React.Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    refScenarioId: PropTypes.any,
  };
  static defaultProps = {
    disabled: false,
    refScenarioId: '',
  };

  static contextType = FormStepContext;

  @observable versionChanges = null;

  async componentDidMount() {
    this.getContext().fields.push(this.props.name);
    const formData = this.instance.formData
    formData.append('ref_scenario_id', this.props.refScenarioId)
    this.versionChanges = (await Scenario.ajaxRequest(
      'POST', '/version_changes/',
      { data: formData,},
    )).data;
  }

  getContext() {
    if (this.context === null) {
      throw Error('No form step context found in FormField ancestors.');
    }
    return this.context;
  }

  get instance() {
    return this.getContext().instance;
  }

  @computed get value() {
    return JSON.parse(this.instance[this.props.name]);
  }

  set value(value) {
    this.instance[this.props.name] = JSON.stringify(value);
  }

  onChange = versionType => {
    return typeValue => {
      this.value = { ...this.value, [versionType]: typeValue };
    };
  };

  render() {
    if (this.versionChanges === null) {
      return <Skeleton variant="rect" width="100%" height={400} />;
    }
    const { disabled } = this.props;
    return (
      <Grid container direction="column" spacing={2} wrap="nowrap">
        {Object.entries(this.versionChanges).map(
          ([versionType, versionChangeData]) =>
            <Grid item key={versionType}>
              <VersionChangesInput
                type={versionType}
                label={versionChangeData.label}
                filters={versionChangeData.filters}
                months={versionChangeData.months === null ? null : [...versionChangeData.months]}
                changeUnit={versionChangeData.change_unit}
                value={versionType in this.value ? this.value[versionType] : []}
                onChange={this.onChange(versionType)}
                helpText={versionChangeData.help_text}
                disabled={disabled}
              />
            </Grid>
        )}
      </Grid>
    );
  }
}


export default VersionChangesField;
